export const getCEPData = (zipCode) => {
   return fetch(`https://viacep.com.br/ws/${zipCode}/json/`);
 }